import { render, staticRenderFns } from "./AssetLocationInput.vue?vue&type=template&id=56bd2627&"
import script from "./AssetLocationInput.vue?vue&type=script&lang=js&"
export * from "./AssetLocationInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports